import { Tag, Tooltip } from "antd";

import { colors } from "@app/theme.ts";

interface CmtRoleTagProps {
  role: string;
}
const tagColor = colors.tagColor;

export const CmtRoleTag = ({ role }: Readonly<CmtRoleTagProps>) => {
  return (
    <Tooltip title={role}>
      <Tag color={tagColor}>{role}</Tag>
    </Tooltip>
  );
};
